import gql from 'graphql-tag';

export const GET_PROPERTY_MIGRATION_STATUS = gql`
  query GetPropertyMigrationStatus($token: String!) {
    PartnerHubQueries {
        getPropertyMigrationStatus(token: $token)
    }
  }
`;